import React, {useEffect, useMemo} from 'react';
import {TroubleshootingWizardProcess} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/TroubleshootingWizardProcess';
import AbroadTroubleshootingWizard from 'app/Components/Block/AbroadTroubleshootingWizardBlock/AbroadTroubleshootingWizard';

const AbroadCallsTroubleshootingWizardBlock = (props) => {
  const {resetState,contentData,context} = props;

  return <AbroadTroubleshootingWizard contentData={contentData} context={context} processName={TroubleshootingWizardProcess.AbroadCellular} />;
};

export default AbroadCallsTroubleshootingWizardBlock;
